import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import { MainTheme } from '@paretogroup/tess';

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const useStyles = makeStyles(() => ({
    saveButton: {
        backgroundColor: MainTheme.colors['fun-green'],
        fontSize: '14px',
        WebkitTextFillColor: MainTheme.colors.white,
        '&:hover': {
            backgroundColor: MainTheme.colors['fun-green'],
            opacity: 0.7,
        },
    },
    clearButton: {
        backgroundColor: MainTheme.colors['gray-5'],
        fontSize: '14px',
        marginTop: '10px',
        WebkitTextFillColor: MainTheme.colors['regal-blue-50'],
    },
}));
